import React, { Component } from "react";
import { withModulesManager, formatMessage } from "@openimis/fe-core";
import { injectIntl } from "react-intl";
import { Grid, Typography, Box } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import EnrollmentTable from "../components/enrollmentTable";

const styles = (theme) => ({
  page: theme.page || {
    margin: theme.spacing(1),
  },
});

class EnrollmentHomePage extends Component {
  render() {
    const { intl, classes } = this.props;

    return (
      <Box className={classes.page}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              {formatMessage(intl, "enrollment", "page.home.welcome")}
            </Typography>
            <Typography variant="body1" color="textSecondary" paragraph>
              {formatMessage(intl, "enrollment", "page.home.description")}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <EnrollmentTable />
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default withModulesManager(
  withStyles(styles)(injectIntl(EnrollmentHomePage))
);
